import { useParams, Link, Navigate } from "react-router-dom";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import { Accordion } from "./Faqs";
import { services } from "../data/content";
import { BOOKING_URL } from "../data/config";

export default function ServiceSingle() {
  const { id } = useParams();
  const service = services.find((s) => s.id === id);
  if (!service) return <Navigate to="/services" replace />;

  return (
    <>
      <PageHeader
        title={service.title}
        crumbs={[{ label: "Services", to: "/services" }, { label: service.title }]}
      />
      <section className="section">
        <div className="container single-layout reverse">
          <aside>
            <div className="sidebar-box">
              <h3>All Services</h3>
              <ul className="sidebar-links">
                {services.map((s) => (
                  <li key={s.id}>
                    <Link to={`/services/${s.id}`} className={s.id === id ? "active" : ""}>
                      {s.title} <FaArrowRight />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="sidebar-box" style={{ textAlign: "center" }}>
              <h3>Need a Ride?</h3>
              <p className="sec-text" style={{ marginBottom: 18 }}>
                Book this service now and travel in comfort.
              </p>
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-block">Book online Now</a>
            </div>
          </aside>

          <div className="single-content">
            <img src={service.image} alt={service.title} className="single-img" />
            <h2>{service.title}</h2>
            <p>{service.desc}</p>

            <h3>Why Choose This Service?</h3>
            <ul className="check-list">
              {service.benefits.map((b, i) => (
                <li key={i}><FaCheckCircle /> {b}</li>
              ))}
            </ul>

            <h3>How It Works</h3>
            <ul className="process-list">
              {service.process.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>

            <h3>Frequently Asked Questions</h3>
            <Accordion items={service.faqs} />
          </div>
        </div>
      </section>
    </>
  );
}
